<div class="text-center" *ngIf="!userService.authService.instance.getAllAccounts().length">
  <h3>{{ "COMPONENTS.LOGIN_FAILED.TITLE" | translate }}</h3>
  <p>{{ "COMPONENTS.LOGIN_FAILED.DESCRIPTION" | translate: {countDown: countDown} }}
</div>
